import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

/**
 * Exports JSON data to Excel file.
 * @param {Array} data - Array of data objects to export
 * @param {String} fileName - Name of the exported file
 * @param {Array} columns - Column definitions: [{ label, key, formatter? }]
 */
export const exportExcel = (data, fileName = "Export", columns = []) => {
  if (!data || data.length === 0) {
    alert("No data to export");
    return;
  }


  const headers = columns.map(col => col.label);
  const keys = columns.map(col => col.key);

  // Map data rows
  const rows = data.map(row =>
    keys.map(key => {
      const colDef = columns.find(c => c.key === key);
      const val = row[key];
      return colDef.formatter ? colDef.formatter(val, row) : val ?? "";
    })
  );

  // Create worksheet
  const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

  // Write and save file
  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(blob, `${fileName}_${new Date().toISOString().split("T")[0]}.xlsx`);
};
